module.exports = {
  email: 'hello@roberteberhard.com',
  tabItems: [
    {
      id: 1,
      title: 'Shopify Design',
      title2: 'Shopify Design Services',
      icon: 'shopify-design',
      style: 'design',
      content: 'Shopify design refers to the process of creating and customizing the visual appearance and layout of an online store using the Shopify platform. This can include choosing a pre-designed theme, customizing the theme with branding and images, and creating pages and collections. It also includes creating a responsive design that works well on both desktop and mobile devices. The goal of Shopify design is to create an online store that is visually appealing, easy to navigate, and effectively showcases the products being sold.',
      example1: "A fashion retailer might use Shopify design to create a visually stunning online store that showcases their clothing and accessories in an elegant and easy-to-navigate layout. This might include creating custom pages for each product line, using high-quality images and videos, and incorporating the brand's colors and fonts throughout the design.",
      example2: "A health and wellness store might use Shopify design to create a clean, minimalist online store that showcases their products in a simple and easy-to-use layout. This might include using white space and simple typography, as well as incorporating a color scheme that evokes health and wellness. The store could feature a blog to promote the brand's mission and values."
    },
    {
      id: 2,
      title: 'Shopify Development',
      title2: 'Shopify Development Services',
      icon: 'shopify-development',
      style: 'development',
      content: 'Shopify development is the process of customizing and integrating existing Shopify features to create a unique, custom e-commerce solution for a business. This process often includes website design, setting up payment gateways, configuring shipping options, adding apps and plugins, and customizing the user experience. The goal of Shopify development is to create an online store that is tailored to the needs and goals of the business.',
      example1: 'A fashion designer wanted to launch an online store to sell her latest collection. She hired a Shopify developer to assist her in designing a visually appealing website and customizing the store’s features to meet her specific needs. The developer worked with the designer to create a unique user experience, integrate payment gateways, and configure shipping options.',
      example2: 'A beauty company wanted to expand their current store to the online marketplace. They hired a Shopify developer to build their website, integrate their existing payment options, and add a variety of plugins and apps to enhance their user experience. The developer also worked with the company to ensure that their store was secure and compliant with all applicable laws and regulations.'
    },
    {
      id: 3,
      title: 'Shopify Marketing',
      title2: 'Shopify Marketing Services',
      icon: 'shopify-marketing',
      style: 'marketing',
      content: 'Shopify marketing refers to the various strategies and tactics used to promote and sell products or services through a Shopify online store. This can include tactics such as search engine optimization, email marketing, social media marketing, and advertising on platforms such as Google and Facebook. The goal of Shopify marketing is to drive traffic and sales to the online store, and ultimately increase revenue for the business.',
      example1: 'A fashion retailer might use Shopify marketing to create a visually appealing online store, optimize product descriptions for SEO, and use email campaigns to target potential customers. Additionally, the retailer could create partnerships with influencers and bloggers to promote their products and increase brand awareness.',
      example2: 'A home decor retailer might use Shopify marketing to create a visually appealing online store, use social media campaigns to showcase products, and use email campaigns to target potential customers. Additionally, the retailer could create content such as tutorials, blogs, and videos to highlight the products and increase engagement with their audience.'
    },
    {
      id: 4,
      title: 'Shopify Support',
      title2: 'Shopify Support Services',
      icon: 'shopify-support',
      style: 'support',
      content: 'Shopify support refers to the services that a Shopify agency can offer to its clients. It includes a number of different services, such as store setup and customization, theme development, app integration, data migration, inventory management, SEO optimization, marketing and advertising, training and education, ongoing support and maintenance, payment gateway integration, and custom development. These services help clients set up, manage, and market their e-commerce store, giving them an edge over their competition.',
      example1: 'A fashion retailer might use Shopify support to customize their store theme to fit the brand’s aesthetic, as well as to seamlessly integrate third-party apps for product reviews, payments, and marketing. They would also benefit from ongoing support to help manage the store and keep up to date with the latest trends and technologies.',
      example2: 'A furniture store might use Shopify support to migrate their data, integrate their inventory management system, and create custom apps to enhance the customer experience. This would help them keep their store up to date and provide their customers with a better shopping experience.'
    }
  ],
  serviceCards: [
    { id: '1', title: 'Shopify Theme Tweaks & Changes', icon: 'shopify-support', desc: 'Need changes to your Shopify store? I can literally code anything into any 2.0 Shopify theme.', url: '/shopify-services/shopify-theme-tweaks-changes', service: 'Support Services' },
    {
      id: '11',
      title: 'Shopify Custom Development',
      icon: 'shopify-development',
      desc: "Do you need a unique and personalized Shopify store that meets your specific needs and goals? I'm here to help you make it happen.",
      url: '/shopify-services/shopify-custom-development',
      service: 'Development Services'
    },
    {
      id: '12',
      title: 'Shopify Advanced Customization',
      icon: 'shopify-development',
      desc: 'Do you want to customize your Shopify store to fit your business? I can help you to customize your store exactly the way you want it and make sure your website is fast, secure, and easy to use.',
      url: '/shopify-services/shopify-advanced-customization',
      service: 'Development Services'
    },
    {
      id: '2',
      title: 'Shopify Converting Hero Images',
      icon: 'shopify-design',
      desc: 'Do you need a professional-looking hero image? I can design a hero banner with all the necessary elements for a higher conversion rate.',
      url: '/shopify-services/converting-hero-images',
      service: 'Design Services'
    },
    {
      id: '3',
      title: 'Shopify Converting Collection Banners',
      icon: 'shopify-design',
      desc: 'Do you need collection banners that convert? I can design beautiful collection banners for a higher conversion rate.',
      url: '/shopify-services/converting-collection-banners',
      service: 'Design Services'
    },
    {
      id: '4',
      title: 'Shopify Newsletter Popups Design',
      icon: 'shopify-design',
      desc: 'Need an attention-grabbing newsletter popup?  I can design newsletter pop-ups that feel like a cohesive part of your site and helps you attract new subscribers.',
      url: '/shopify-services/newsletter-popups-design',
      service: 'Design Services'
    },
    {
      id: '5',
      title: 'Shopify Email Header Design',
      icon: 'shopify-design',
      desc: 'Need an email header that is aligned with your campaign goals? I can design an attractive email header that will leave a long-lasting visual impression and increase your conversion rates.',
      url: '/shopify-services/email-header-design',
      service: 'Design Services'
    },
    {
      id: '6',
      title: 'Converting Newsletter Design',
      icon: 'shopify-design',
      desc: 'Need an appealing designed newsletter? I can design a newsletter that fits your brand, stands out from the crowd, and effectively conveys your message.',
      url: '/shopify-services/converting-newsletter-design',
      service: 'Design Services'
    },
    {
      id: '7',
      title: 'Shopify Custom Icon Design',
      icon: 'shopify-design',
      desc: "Do you need icons that best match your 's statements and services? I can design icons that align with your brand and can be used on multiple platforms.",
      url: '/shopify-services/custom-icon-design',
      service: 'Design Services'
    },
    {
      id: '8',
      title: 'Banner Ads That Convert',
      icon: 'shopify-design',
      desc: 'Need some Eye-catching banner ads? I can design appealing banner ads that meet all the requirements of the display advertising network of your choice and increase your sales.',
      url: '/shopify-services/banner-ads-that-convert',
      service: 'Design Services'
    },
    {
      id: '9',
      title: 'Social Media Ads That Convert',
      icon: 'shopify-design',
      desc: 'Do you need optimized social media ads?  I can create high-converting social media ads that meet all requirements of the platform(s) of your choice.',
      url: '/shopify-services/social-media-ads-that-convert',
      service: 'Design Services'
    },
    {
      id: '10',
      title: 'Social Media Cover Photos',
      icon: 'shopify-design',
      desc: "Do you need social media covers with your branding? I can design visually appealing covers that fit your brand's identity and are suited for your chosen social media platforms.",
      url: '/shopify-services/social-media-cover-photos',
      service: 'Design Services'
    },
    {
      id: '11',
      title: '13. Shopify Theme Tweaks & Changes',
      icon: 'shopify-marketing',
      desc: 'Need changes to your Shopify site? We can code literally anything into any Shopify theme.',
      url: '/shopify-services/shopify-theme-tweaks-changes',
      service: 'Marketing Services'
    }
  ],
  headerLinks: [
    {
      name: 'Home',
      url: '/'
    },
    {
      name: 'Shopify Services',
      url: '/shopify-services'
    },
    {
      name: 'Tools',
      url: '/tools'
    },
    {
      name: 'Contact',
      url: '/contact'
    }
  ],
  footerLinks: [
    {
      name: 'Shopify Services',
      url: '/shopify-services'
    },
    {
      name: 'Tools & Apps',
      url: '/tools'
    },
    {
      name: 'Contact',
      url: '/contact'
    },
    {
      name: 'Imprint',
      url: '/imprint'
    },
    {
      name: 'Privacy Policy',
      url: '/privacy-policy'
    },
    {
      name: 'Cookie Policy',
      url: '/cookie-policy'
    }
  ],
  shopifyLinks: [
    {
      name: 'Theme Tweaks & Changes',
      url: '/shopify-services/shopify-theme-tweaks-changes'
    },
    {
      name: 'Advanced Customization',
      url: '/shopify-services/shopify-advanced-customization'
    },
    {
      name: 'Custom Development',
      url: '/shopify-services/shopify-custom-development'
    },
    {
      name: 'Social Media Cover Photos',
      url: '/shopify-services/social-media-cover-photos'
    },
    {
      name: 'Social Media Ads That Convert',
      url: '/shopify-services/social-media-ads-that-convert'
    },
    {
      name: 'Converting Hero Images',
      url: '/shopify-services/converting-hero-images  '
    }
  ],
  followLinks: [
    {
      name: 'GitHub',
      url: 'https://github.com/roberteberhard'
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/robert-eberhard-dev'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/robert_eberhard'
    }
  ],
  brandIcons: [
    {
      name: 'ABB'
    },
    {
      name: 'Accenture'
    },
    {
      name: 'Appenzeller'
    },
    {
      name: 'Arvato'
    },
    {
      name: 'ASA'
    },
    {
      name: 'BMW'
    },
    {
      name: 'CreditSuisse'
    },
    {
      name: 'Post'
    },
    {
      name: 'Ebookers'
    },
    {
      name: 'Mars'
    },
    {
      name: 'ProHelvetia'
    },
    {
      name: 'Roche'
    },
    {
      name: 'SAP'
    },
    {
      name: 'SBB'
    },
    {
      name: 'Swatch'
    },
    {
      name: 'SwissLife'
    },
    {
      name: 'Telekom'
    },
    {
      name: 'UBS'
    },
    {
      name: 'UnionInvestment'
    },
    {
      name: 'WaltDisney'
    }
  ]
}
